<template>
  <el-dialog
    :title="`${user._id ? 'Edit' : 'New'} Customer`" :model-value="flagVisible" width="30%"
    :before-close="handleClose"
  >
    <el-form ref="form" :model="user" label-position="top" size="small">
      <el-form-item>
        <el-input v-model="user.email" placeholder="Email" :disabled="user._id !== ''"></el-input>
      </el-form-item>
      <el-form-item>
        <el-select
          v-model="user.master_brand_id" filterable style="width: 100%;" placeholder="Select Master Brand"
          @change="selectBrand"
        >
          <el-option v-for="(item) in brands" :key="item._id" :label="item.name" :value="item._id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-input v-model="user.company_name" placeholder="Company Name"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="user.first_name" placeholder="First name"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="user.last_name" placeholder="Last name"></el-input>
      </el-form-item>
      <el-form-item v-if="!user._id">
        <el-input type="password" v-model="user.password" placeholder="Password"></el-input>
      </el-form-item>
      <el-form-item v-if="!user._id">
        <el-input type="password" v-model="user.password_confirm" placeholder="Confirm Password"></el-input>
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button size="small" @click="handleClose">CANCEL</el-button>
        <el-button size="small" class="el-btn-blue" :loading="flagLoading.save" @click="handleSave">Save</el-button>
      </span>
    </template>
  </el-dialog>
</template>
<script>
import { reactive } from 'vue'
import _ from 'lodash'
const md5 = require('md5')
export default {
  props: {
    flagVisible: Boolean,
    actionItem: Object
  },
  emits: ['closeModal', 'reloadData'],
  data: function () {
    const flagLoading = reactive({
      save: false
    })
    return {
      user: this.actionItem,
      brands: [],
      flagLoading
    }
  },
  created: function () {
    this.getBrands()
  },
  watch: {
    actionItem: {
      handler: function (val, oldVal) {
        this.user = val
      },
      deep: true
    }
  },
  methods: {
    handleClose: function () {
      this.$emit('closeModal')
    },
    handleSave: function () {
      if (this.user._id) {
        this.updateUser()
      } else {
        this.createUser()
      }
    },
    getBrands: function () {
      const url = '/api/v1/atk_player/admin/brands?page_num=1&page_size=1000&is_deleted=false'
      const that = this
      this.$service.get(url).then(function (res) {
        if (res.code === 200) {
          that.brands = res.data.list
        }
      }).catch(function (err) {
        console.error('getBrands', err)
      })
    },
    createUser: function () {
      const { email, password } = this.user
      const passwordConfirm = this.user.password_confirm
      this.user.master_brand_status = 'active'
      if (email.length <= 0) {
        this.$message.warning('Email is required')
        return
      }
      if (password.length <= 0 || password !== passwordConfirm) {
        this.$message.warning('Password and confirm password must match')
        return
      }
      this.flagLoading.save = true
      const url = '/api/v1/atk_player/admin/users'
      const that = this
      const body = { ...this.user }
      body.password = md5(body.password)
      body.password_confirm = md5(body.password_confirm)
      this.$service.post(url, body).then(function (res) {
        if (res.code === 200) {
          that.$message({ type: 'success', message: 'Create customer success' })
          that.handleClose()
          setTimeout(function () {
            that.$emit('reloadData')
          }, 100)
        } else {
          that.$message({ type: 'error', message: res.msg })
        }
        that.flagLoading.save = false
      }).catch(function (err) {
        console.error('createUser', err)
        that.$message({ type: 'error', message: err.msg })
        that.flagLoading.save = false
      })
    },
    updateUser: function () {
      this.flagLoading.save = true
      const url = `/api/v1/atk_player/admin/users/${this.user._id}`
      const that = this
      this.$service.put(url, this.user).then(function (res) {
        if (res.code === 200) {
          that.$message({ type: 'success', message: 'Update customer success' })
          that.handleClose()
          setTimeout(function () {
            that.$emit('reloadData')
          }, 100)
        } else {
          that.$message({ type: 'error', message: res.msg })
        }
        that.flagLoading.save = false
      }).catch(function (err) {
        console.error('updateUser', err)
        that.$message({ type: 'error', message: err.msg })
        that.flagLoading.save = false
      })
    },
    selectBrand: function (val) {
      const brandIndex = _.findIndex(this.brands, { _id: val })
      if (brandIndex >= 0) {
        this.user.master_brand_name = this.brands[brandIndex].name
      }
    }
  }
}
</script>

<style scoped lang="scss">
</style>
